function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Iconly/Bulk/Message"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  opacity: 0.4,
  d: "M22 15.941C22 18.731 19.76 20.991 16.97 21.001H16.96H7.05C4.27 21.001 2 18.751 2 15.961V15.951C2 15.951 2.006 11.525 2.014 9.29898C2.015 8.88098 2.495 8.64698 2.822 8.90698C5.198 10.792 9.447 14.229 9.5 14.274C10.21 14.843 11.11 15.164 12.03 15.164C12.95 15.164 13.85 14.843 14.56 14.263C14.613 14.228 18.767 10.894 21.179 8.97798C21.507 8.71698 21.989 8.95098 21.99 9.36798C22 11.577 22 15.941 22 15.941Z",
  fill: "#8B8B8B"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 4",
  d: "M21.4761 5.674C20.6101 4.042 18.9061 3 17.0301 3H7.05013C5.17413 3 3.47013 4.042 2.60413 5.674C2.41013 6.039 2.50213 6.494 2.82513 6.752L10.2501 12.691C10.7701 13.111 11.4001 13.32 12.0301 13.32C12.0341 13.32 12.0371 13.32 12.0401 13.32C12.0431 13.32 12.0471 13.32 12.0501 13.32C12.6801 13.32 13.3101 13.111 13.8301 12.691L21.2551 6.752C21.5781 6.494 21.6701 6.039 21.4761 5.674Z",
  fill: "#8B8B8B"
})));
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.cf6d467f.svg";
export { ForwardRef as ReactComponent };